/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_6_Paragraphs_1Inputs */

const en_gc_search_guides_gridcraft_online_sections_6_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_6_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If a sample works but your own file does not, preserve the original and inspect the file type and size. Try a smaller copy with only the relevant sheet, or a simple XLSX workbook whose result you know. Do not diagnose every file failure as a browser problem. The compatibility guide explains why a supported extension still does not guarantee that every advanced object or calculation will behave as expected.`)
};

const zh_gc_search_guides_gridcraft_online_sections_6_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_6_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果示例可用，而自己的文件失败，请保留原件并检查文件类型与大小。可以尝试只保留相关工作表的小副本，或结果已知的简单 XLSX 文件。不要把所有文件故障都归因于浏览器。兼容性指南说明了为什么支持某个扩展名，也不代表所有高级对象和计算都能符合预期。`)
};

/**
* | output |
* | --- |
* | "If a sample works but your own file does not, preserve the original and inspect the file type and size. Try a smaller copy with only the relevant sheet, or a..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_6_Paragraphs_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_6_paragraphs_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_6_Paragraphs_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_6_Paragraphs_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_6_paragraphs_1(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_6_paragraphs_1(inputs)
});
export { gc_search_guides_gridcraft_online_sections_6_paragraphs_1 as "gc.search_guides.gridcraft_online.sections.6.paragraphs.1" }